import { useThemeContext } from "./ThemeContext";

/**
 * Looping 3D empty-state animations, shared with the Listaa app
 * (`lib/core/widgets/empty_state_gif.dart`). GIF transparency is on/off, so each
 * animation ships with edges blended for light pages and for dark/glassy pages.
 */
export type EmptyArt =
  | "about" | "bottles" | "cart" | "chats" | "contacts" | "events" | "faq"
  | "favourites" | "filters" | "friends" | "gift_cards" | "invite" | "map"
  | "media" | "menu" | "notifications" | "person_search" | "reviews" | "rooms"
  | "search" | "tags" | "tickets" | "videos";

const ASPECT: Partial<Record<EmptyArt, number>> = { invite: 200 / 180 };

export function EmptyStateGif({
  art,
  size = 120,
  light,
  className = "",
}: {
  art: EmptyArt;
  /** Height in px; width follows the art's aspect ratio. */
  size?: number;
  /** Whether it sits on a light surface; defaults to the site theme. Screens with their own palette pass it. */
  light?: boolean;
  className?: string;
}) {
  const { isLight } = useThemeContext();
  const variant = (light ?? isLight) ? "light" : "dark";
  return (
    <img
      src={`/animations/empty/${art}_${variant}.gif`}
      alt=""
      aria-hidden="true"
      loading="lazy"
      decoding="async"
      draggable={false}
      height={size}
      width={Math.round(size * (ASPECT[art] ?? 1))}
      className={`object-contain select-none mx-auto ${className}`}
    />
  );
}
